var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cta_listing"},[_c('div',{staticClass:"inner"},_vm._l((JSON.parse(_vm.ctas)),function(cta,index){return _c('cta-listing-item',{key:index,attrs:{"title":cta.title,"permalink":cta.link,"background":cta.image,"category":cta.category}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/forge/signs.stagingwebsite.dev/web/app/themes/signs/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/forge/signs.stagingwebsite.dev/web/app/themes/signs/node_modules/vue-loader/lib?{}!./scripts/vue/CtaListing.vue?vue&type=template&id=ad8a8bba&scoped=true&
// module id = 373
// module chunks = 0